import { createContext as e, useCallback as t, useContext as n, useEffect as r, useMemo as i, useRef as a, useState as o } from "react";
import { createInstance as s } from "i18next";
import c from "i18next-http-backend";
import { initReactI18next as l, useTranslation as u } from "react-i18next";
import { getCookie as d, setCookie as f } from "@frontends/util-utils";
import { I18nProvider as p } from "react-aria";
import { jsx as m } from "react/jsx-runtime";
//#region src/lib/locales.ts
var h = {
	country: "gb",
	language: "en-GB",
	name: "English"
}, g = [
	{
		country: "ae",
		language: "ar-SA",
		name: "Arabic"
	},
	{
		country: "cn",
		language: "zh-CN",
		name: "Chinese"
	},
	h,
	{
		country: "fr",
		language: "fr-FR",
		name: "French"
	},
	{
		country: "de",
		language: "de-DE",
		name: "German"
	},
	{
		country: "id",
		language: "id-ID",
		name: "Indonesian"
	},
	{
		country: "jp",
		language: "ja-JP",
		name: "Japanese"
	},
	{
		country: "kr",
		language: "ko-KR",
		name: "Korean"
	},
	{
		country: "pl",
		language: "pl-PL",
		name: "Polish"
	},
	{
		country: "pt",
		language: "pt-PT",
		name: "Portuguese"
	},
	{
		country: "ru",
		language: "ru-RU",
		name: "Russian"
	},
	{
		country: "es",
		language: "es-ES",
		name: "Spanish"
	},
	{
		country: "th",
		language: "th-TH",
		name: "Thai"
	},
	{
		country: "tr",
		language: "tr-TR",
		name: "Turkish"
	},
	{
		country: "vn",
		language: "vi-VN",
		name: "Vietnamese"
	}
], _ = h, v = [...g], y = _.language, b = v.map((e) => e.language);
function x(e) {
	return e.trim().replace(/_/g, "-").toLowerCase();
}
function S(e) {
	return x(e).split("-")[0];
}
var C = v.map((e) => S(e.language));
function w(e) {
	let t = S(e);
	return C.includes(t) ? t : S(y);
}
function T(e) {
	let t = e ? x(e) : "";
	if (!t) return null;
	let n = v.find((e) => e.language.toLowerCase() === t);
	if (n) return n;
	let r = S(t);
	return v.find((e) => S(e.language) === r) ?? null;
}
function E(e) {
	return T(e) ?? _;
}
function D(e, t) {
	return t === void 0 || t.includes(e.language) ? e : _;
}
function O(e) {
	return e !== null && b.includes(e);
}
//#endregion
//#region src/lib/browserLocale.ts
function k() {
	if (typeof navigator > "u") return null;
	let e = navigator.languages?.length ? navigator.languages : [navigator.language];
	for (let t of e) {
		let e = T(t);
		if (e) return e;
	}
	return null;
}
//#endregion
//#region src/lib/extractConfig.ts
var A = {
	locales: [...b],
	extract: {
		functions: [
			"t",
			"*.t",
			"marker"
		],
		transComponents: ["Trans"],
		useTranslationNames: ["useTranslation"],
		keySeparator: ".",
		nsSeparator: ":",
		sort: !0,
		indentation: 2,
		removeUnusedKeys: !0,
		primaryLanguage: "en-GB",
		defaultValue: ""
	}
};
//#endregion
//#region src/lib/formatLocale.ts
function j(e) {
	try {
		let { locale: t } = Intl.DateTimeFormat().resolvedOptions(), n = new Intl.Locale(t).region;
		return n ? `${w(e)}-${n}` : e;
	} catch {
		return e;
	}
}
//#endregion
//#region src/lib/context/LocaleContext.ts
var M = e(null);
//#endregion
//#region src/lib/hooks/useLocale.ts
function N() {
	let e = n(M);
	if (!e) throw Error("useLocale must be used within a LocaleProvider");
	return e;
}
//#endregion
//#region src/lib/address.ts
var P = "locale", F = "isLanguageSelectorDisabled";
function I(e) {
	return typeof window > "u" ? null : new URLSearchParams(window.location.search).get(e);
}
function L() {
	return I(P);
}
function R() {
	if (L() === null) return;
	let e = new URL(window.location.href);
	e.searchParams.delete(P), window.history.replaceState(window.history.state, document.title, e.pathname + e.search + e.hash);
}
function z() {
	let e = I(F);
	return e !== null && e !== "" && e !== "false";
}
//#endregion
//#region src/lib/initialLocale.ts
var B = "locale";
function V(e = B) {
	return typeof window > "u" ? _ : T(L()) ?? T(d(e)) ?? k() ?? _;
}
//#endregion
//#region src/lib/initI18n.ts
function H(e) {
	let { namespaces: t, defaultNS: n, loadPath: r, offeredLanguages: i, debug: a = !1 } = e, o = s();
	return o.use(c).use(l).init({
		debug: a,
		lng: D(V(), i).language,
		load: "currentOnly",
		fallbackLng: y,
		supportedLngs: b,
		ns: t,
		defaultNS: n,
		backend: { loadPath: r },
		interpolation: { escapeValue: !1 },
		returnEmptyString: !1
	}), o;
}
//#endregion
//#region src/lib/marker.ts
var U = (e) => e;
//#endregion
//#region src/lib/providers/FormatLocaleProvider.tsx
function W({ language: e, children: t }) {
	return /* @__PURE__ */ m(p, {
		locale: i(() => j(e), [e]),
		children: t
	});
}
//#endregion
//#region src/lib/providers/LocaleProvider.tsx
function G({ locale: e, offeredLanguages: n, onLocaleChange: s, storageKey: c = B, children: l }) {
	let { i18n: d } = u(void 0, { useSuspense: !1 }), p = e !== void 0, [h, g] = o(() => p ? _ : V(c)), v = D(e ?? h, n), y = a(s);
	y.current = s;
	let b = i(() => z(), []);
	r(() => {
		p || R();
	}, [p]), r(() => {
		d.changeLanguage(v.language), document.documentElement.setAttribute("dir", d.dir(v.language)), document.documentElement.setAttribute("lang", v.language);
	}, [d, v.language]), r(() => {
		p || f(c, h.language);
	}, [
		p,
		h.language,
		c
	]);
	let x = t((t) => {
		y.current?.(t), e === void 0 && g(t);
	}, [e]), S = i(() => ({
		locale: v,
		isLanguageSelectorDisabled: b,
		setLocale: x
	}), [
		v,
		b,
		x
	]);
	return /* @__PURE__ */ m(M.Provider, {
		value: S,
		children: /* @__PURE__ */ m(W, {
			language: v.language,
			children: l
		})
	});
}
//#endregion
//#region src/lib/testing/createTestI18n.ts
function K({ language: e = y, namespace: t, resources: n } = {}) {
	let r = s(), i = t !== void 0 && n !== void 0;
	return r.use(l).init({
		lng: e,
		load: "currentOnly",
		fallbackLng: y,
		supportedLngs: b,
		ns: t === void 0 ? void 0 : [t],
		defaultNS: t,
		resources: i ? { [e]: { [t]: n } } : {},
		initAsync: !1,
		interpolation: { escapeValue: !1 }
	}), {
		i18n: r,
		t: r.getFixedT(e, t)
	};
}
//#endregion
export { y as FALLBACK_LANGUAGE, _ as FALLBACK_LOCALE, W as FormatLocaleProvider, v as LOCALES, G as LocaleProvider, b as SUPPORTED_LANGUAGES, A as baseExtractConfig, K as createTestI18n, E as findLocale, H as initI18n, O as isSupportedLanguage, U as marker, k as resolveBrowserLocale, j as resolveFormatLocale, T as resolveLocale, w as toLanguageCode, N as useLocale };
